// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8c24667f","94":"c35f7f43","342":"93dfddf1","413":"8fdabef0","512":"54044e33","605":"9ab1831c","695":"2c14aa87","707":"91d8e2ff"}[chunkId] + ".chunk.js";
};